export default "__VITE_ASSET__BTfa7eNg__"